export default "__VITE_ASSET__BykX624L__"